import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';

export function PaymentCancelPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#02040A] flex items-center justify-center p-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-md w-full bg-gradient-to-b from-white/10 to-transparent backdrop-blur-xl border border-white/20 rounded-3xl p-8 shadow-2xl text-center"
      >
        <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-red-500/20 flex items-center justify-center">
          <XCircle className="w-8 h-8 text-red-500" />
        </div>
        
        <h2 className="text-3xl font-bold text-white mb-2">Pago Cancelado</h2>
        <p className="text-white/60 mb-6">
          Has cancelado el proceso de pago. No se ha realizado ningún cargo.
        </p>

        <div className="space-y-3">
          <button
            onClick={() => navigate('/')}
            className="w-full bg-[#C5A14C] text-[#02040A] font-bold rounded-full px-8 py-4 hover:bg-[#B08F3C] transition-all duration-300"
          >
            Volver al Inicio
          </button>
          
          <button
            onClick={() => navigate(-2)}
            className="w-full bg-white/10 text-white font-bold rounded-full px-8 py-4 hover:bg-white/20 transition-all duration-300"
          >
            Intentar Nuevamente
          </button>
        </div>
      </motion.div>
    </div>
  );
}
